export default __webpack_public_path__ + "assets/images/a4443ae7e7f8c25af32b122078cee3e8.png";